/* tslint:disable */
/* eslint-disable */
/**
 * BS BFF(ダイナミックパッケージ/DP補助金申請) API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface JpCoBenefitoneBsSubsidyDtoCouponGetInfV2
 */
export interface JpCoBenefitoneBsSubsidyDtoCouponGetInfV2 {
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsSubsidyDtoCouponGetInfV2
     */
    subsidyDetailId?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsSubsidyDtoCouponGetInfV2
     */
    couponId?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsSubsidyDtoCouponGetInfV2
     */
    customerNo?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsSubsidyDtoCouponGetInfV2
     */
    getDate?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsSubsidyDtoCouponGetInfV2
     */
    usedFlag?: string;
    /**
     * 
     * @type {number}
     * @memberof JpCoBenefitoneBsSubsidyDtoCouponGetInfV2
     */
    parsonalAssignmentCnt?: number;
}

export function JpCoBenefitoneBsSubsidyDtoCouponGetInfV2FromJSON(json: any): JpCoBenefitoneBsSubsidyDtoCouponGetInfV2 {
    return JpCoBenefitoneBsSubsidyDtoCouponGetInfV2FromJSONTyped(json, false);
}

export function JpCoBenefitoneBsSubsidyDtoCouponGetInfV2FromJSONTyped(json: any, ignoreDiscriminator: boolean): JpCoBenefitoneBsSubsidyDtoCouponGetInfV2 {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'subsidyDetailId': !exists(json, 'subsidyDetailId') ? undefined : json['subsidyDetailId'],
        'couponId': !exists(json, 'couponId') ? undefined : json['couponId'],
        'customerNo': !exists(json, 'customerNo') ? undefined : json['customerNo'],
        'getDate': !exists(json, 'getDate') ? undefined : json['getDate'],
        'usedFlag': !exists(json, 'usedFlag') ? undefined : json['usedFlag'],
        'parsonalAssignmentCnt': !exists(json, 'parsonalAssignmentCnt') ? undefined : json['parsonalAssignmentCnt'],
    };
}

export function JpCoBenefitoneBsSubsidyDtoCouponGetInfV2ToJSON(value?: JpCoBenefitoneBsSubsidyDtoCouponGetInfV2 | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'subsidyDetailId': value.subsidyDetailId,
        'couponId': value.couponId,
        'customerNo': value.customerNo,
        'getDate': value.getDate,
        'usedFlag': value.usedFlag,
        'parsonalAssignmentCnt': value.parsonalAssignmentCnt,
    };
}

